import React, { useEffect, useState } from "react";
import Moment from "react-moment";
import { getFormatedNumber, getFieldData } from "../../services/appService";
import AddEditDuration from "../../components/OMCRegistry/AddEditDuration";
import ViewRegistration from "../../components/OMCRegistry/ViewRegistration";
import ViewCandidate from "../../components/OMCRegistry/ViewCandidate";
import { getAddedDurationObj } from "../store/duration";
import { useDispatch, useSelector } from "react-redux";
import AddEditRates from "../../components/OMCRegistry/AddEditRates";
import { getAddedRateObj } from "../store/rates";
import {
    filterRecruiterClear, getFilterAllRecruiters, getFilterAllRecruiters2, getRecCurrentWfTask, getRecruiterBprmForm, loadRecruiterBprmForm,
    loadRecruitersByFilter, loadRecruitersByFilter2, loadRecruiterWfTask, recCurrentWfTaskReceived,
    receivedRecruiterById,
    recruiterBprmFormReceived
} from "../store/recruiter";
import {
    filterSubcontractorsClear, getFilterAllSubcontractors, getFilterAllSubcontractors2, getSubcontractorBprmForm,
    getSubsCurrentWfTask, loadSubcontractorBprmForm, loadSubcontractorsByFilter, loadSubcontractorsByFilter2,
    loadSubcontractorWfTask, receivedSubcontractorById, subcontractorBprmFormReceived, subsCurrentWfTaskReceived
} from "../store/subcontractor";
import Document from "../../components/PortalForms/Document";
import config from "../../config.json";
import { candidateBprmFormReceived, getCandidateApps, getCandidateBprmForm, loadCandidateApps, loadCandidateBprmForm, receivedCandidateById } from "../store/candidate";
import WorkflowElement from "./WorkflowElement";
import InsuranseInformation from "../../ReviewTools/InsuranseInformation";
import AchInformation from "../../ReviewTools/AchInformation";
import PurchaseOrderPopup from "../../ReviewTools/PurchaseOrderPopup";
import { formLibraryReceived } from "../store/forms";
import { documentReceived, esignDocumentsReceived, reqDocumentReceived } from "../store/documents";
import RateEncryptDecrypt from "../../services/RateEncryptDecrypt";


export default function CandidateInfo(props) {
    const { candidate, handleSectionHideShow, type, currentTask, app } = props;

    const [durationShowHide, setDurationShowHide] = useState(false);
    const [regShowHide, setRegShowHide] = useState(false);
    const [viewShowHide, setViewShowHide] = useState(false);
    const [editDurType, setEditDurType] = useState("");
    const [viewType, setViewType] = useState("");
    const [item, setItem] = useState("");
    const [selectedKey, setSelectedKey] = useState(-1);
    const [selectedInfo, setSelectedInfo] = useState("");
    const [wfflowtask, setWfflowtask] = useState("");
    const [infoItem, setInfoItem] = useState("");
    const [infoApp, setInfoApp] = useState("");
    const [SelectedFormKey, setSelectedFormKey] = useState(-1);
    const [wfTask, setWfTask] = useState(null);
    const [wfForm, setWfForm] = useState(null);
    const [wfId, setWfId] = useState(0);
    const [entityType, setEntityType] = useState(null);
    const [w2Type, setW2type] = useState(null);
    const [candidateObj, setCandidateObj] = useState(null);
    const [updatedStateData, setUpdatedStateData] = useState(null);
    const [viewFormType, setViewFormType] = useState("");
    const [selectedCurrentTask, setSelectedCurrentTask] = useState("");
    const [selectedApp, setSelectedApp] = useState("");
    const [fetchedDataType, setFetchedDataType] = useState("");
    const [appDocuments, setAppDocuments] = useState([]);
    const [viewBprmFormShowHide, setViewBprmFormShowHide] = useState(false);
    const [achType, setAchType] = useState("");
    const [insuranceType, setInsuranceType] = useState("");
    const [purchaseShowHide, setPurchaseShowHide] = useState(false);
    const [poOrderType, setPoOrderType] = useState("");
    const [selectedItem, setSelectedItem] = useState(null);
    const [contractDocType, setContractDocType] = useState("");
    const [partnerCurrentWfTask, setPartnerCurrentWfTask] = useState(null);
    const [partnerAppData, setPartnerAppData] = useState(null);

    const addedDurationObjSelector = useSelector(getAddedDurationObj);
    const addedRateObjSelector = useSelector(getAddedRateObj);
    const filterAllSubcontractors = useSelector(getFilterAllSubcontractors);
    const filterAllRecruiters = useSelector(getFilterAllRecruiters);

    const candidateBprmFormSelector = useSelector(getCandidateBprmForm);
    const subcontractorBprmFormSelector = useSelector(getSubcontractorBprmForm);
    const recruiterBprmFormSelector = useSelector(getRecruiterBprmForm)
    const filterAllSubcontractors2 = useSelector(getFilterAllSubcontractors2);
    const filterAllRecruiters2 = useSelector(getFilterAllRecruiters2);
    const candidateAppsSelector = useSelector(getCandidateApps);

    const subsCurrentWfTaskSelector = useSelector(getSubsCurrentWfTask);
    const recCurrentWfTaskSelector = useSelector(getRecCurrentWfTask);

    const dispatch = useDispatch()

    useEffect(() => {
        if (candidate) setItem(candidate);
        if (currentTask) setSelectedCurrentTask(currentTask);
    }, [candidate, currentTask])



    const handleDurationShowHide = (obj, type, key) => {
        closeACHInsu()
        setSelectedCurrentTask("")
        setWfForm(null)
        setEditDurType("");
        setSelectedApp(null);

        if (key === -1) {
            handleSectionHideShow(false)
        }

        if (type === "save") {
            setEditDurType("");
            handleSectionHideShow(false)
        }
        else {
            setEditDurType(type);
            handleSectionHideShow(true)
        }
        setViewType("");

        if (viewType === type) {
            setViewShowHide(false);
            handleSectionHideShow(false)
            setViewType("");
        }
    };

    useEffect(() => {
        if (addedDurationObjSelector) {
            const objItem = { ...item };
            objItem.duration = addedDurationObjSelector;
            setItem(objItem);
        }
    }, [addedDurationObjSelector]);

    useEffect(() => {
        setWfForm(subcontractorBprmFormSelector);
    }, [subcontractorBprmFormSelector])

    useEffect(() => {
        setWfForm(recruiterBprmFormSelector);
    }, [recruiterBprmFormSelector])

    useEffect(() => {
        if (addedRateObjSelector) {
            const objItem = { ...item };
            objItem.rates = addedRateObjSelector;
            setItem(objItem);
        }
    }, [addedRateObjSelector]);

    const handleDurationChanges = (newObj) => {
        setEditDurType("");
        setDurationShowHide(false);
        setViewType("");
    };

    const handlViewRegistration = () => {
        setRegShowHide(!regShowHide);
        //setSelectedObj(item);
    };

    const handleViewShowHide = (view) => {
        console.log(view);
        if (viewType === view) return;
        setSelectedCurrentTask("")
        setWfForm(null)
        setEditDurType("");
        setSelectedApp(null);
        setEditDurType("");
        setViewFormType("")
        // if (viewType === view) {
        //     setViewShowHide(false);
        //     handleSectionHideShow(false)
        //     setViewType("");
        // } else {
        //     setViewType(view);
        //     setViewShowHide(true);
        //     handleSectionHideShow(true)
        // }
        setViewType(view);
        setViewShowHide(true);
        handleSectionHideShow(true)
    };

    const handleDocumentViewShowHide = (type, item) => {
        if (editDurType === type) return;
        closeACHInsu();
        setSelectedFormKey(-1)
        setEditDurType(type);
        setViewShowHide(false);
        setFetchedDataType("Document");
        handleSectionHideShow(true);
        const tsk = app?.workflowTasks[app.workflowTasks.length - 1];
        setSelectedCurrentTask(tsk);
        // if (type === "Candidate" || type === "agency" || type === "msp") {
        //     const tsk = app.workflowTasks[app.workflowTasks.length - 1];
        //     setSelectedCurrentTask(tsk);
        // }
        // else {
        //     setSelectedCurrentTask(null);
        // }
    };

    const handleCloseDocumentView = () => {
        setFetchedDataType("");
        setSelectedKey(-1);
        setSelectedCurrentTask(null);
        setEditDurType("");
        handleSectionHideShow(false);
        dispatch(documentReceived([]));
        dispatch(subsCurrentWfTaskReceived(null));
        dispatch(recCurrentWfTaskReceived(null));
        dispatch(formLibraryReceived([]));
        dispatch(reqDocumentReceived([]));
        dispatch(esignDocumentsReceived([]));
    }

    const handleViewcandidateForm = (type, key, item) => {

        if (viewFormType === type) return;

        setSelectedKey(-1);
        setViewFormType(type);
        setFetchedDataType("Form")
        setSelectedFormKey(key);
        setCandidateObj(item);
        handleSectionHideShow(true);
        if (type === "Candidate") {
            const entType = getFieldData(item.performerData, "candidateonboardingform", "CandidateEntity");
            const w9type = getFieldData(item.performerData, "candidateonboardingform", "w9_Type");
            setEntityType(entType);
            setW2type(w9type);
            dispatch(candidateBprmFormReceived(null));
            setCandidateType(entType);
        } else if (type === "Subcontractor") {
            dispatch(loadSubcontractorBprmForm(config.formIds.subcontractor));
            dispatch(loadSubcontractorWfTask(item?.subcontractor?.parentid));
        } else if (type === "Recruiter") {
            dispatch(loadRecruiterBprmForm(config.formIds.recruiter));
            dispatch(loadRecruiterWfTask(item?.recruiter?.parentid));
        }
    }

    useEffect(() => {
        if (subsCurrentWfTaskSelector) {
            setPartnerCurrentWfTask(subsCurrentWfTaskSelector);
            setWfTask({ formId: config.formIds.subcontractor, ciid: subsCurrentWfTaskSelector.ciid });
            setPartnerAppData(subsCurrentWfTaskSelector.appData);
        }
    }, [subsCurrentWfTaskSelector])

    useEffect(() => {
        if (recCurrentWfTaskSelector) {
            setPartnerCurrentWfTask(recCurrentWfTaskSelector);
            setWfTask({ formId: config.formIds.recruiter, ciid: recCurrentWfTaskSelector.ciid });
            setPartnerAppData(recCurrentWfTaskSelector.appData);
        }
    }, [recCurrentWfTaskSelector])

    const setCandidateType = (entType) => {

        let appCiid = 0;
        if (candidateObj?.applications?.length > 0) {
            const allWfTasks = candidateObj?.applications[0].workflowTasks;
            if (allWfTasks?.length > 0) {
                appCiid = allWfTasks[allWfTasks.length - 1].ciid;
            }
        }

        if (entType === "C2C Basis") {
            setWfTask({ formId: config.formIds.candidate.C2C_Basis, ciid: appCiid });
            setWfId(config.workflowsIds.candidate.C2C_Basis);
            dispatch(loadCandidateBprmForm(config.formIds.candidate.C2C_Basis))
        }
        if (entType === "W2 Basis") {
            setWfTask({ formId: config.formIds.candidate.W2_Basis, ciid: appCiid });
            setWfId(config.workflowsIds.candidate.W2_Basis);
            dispatch(loadCandidateBprmForm(config.formIds.candidate.W2_Basis));
        }
        if (entType === "1099 Basis") {
            setWfTask({ formId: config.formIds.candidate.Ten_99_Basis, ciid: appCiid });
            setWfId(config.workflowsIds.candidate.Ten_99_Basis);
            dispatch(loadCandidateBprmForm(config.formIds.candidate.Ten_99_Basis))
        }
    }

    useEffect(() => {
        if (candidateObj) {
            if (candidateObj.applications?.length > 0) {
                setUpdatedStateData(candidateObj.applications[0].applicationData);
            }
            else {
                setUpdatedStateData(candidateObj.performerData)
            }
        } else {
            setUpdatedStateData(null);
        }
    }, [candidateObj])

    useEffect(() => {
        setWfForm(candidateBprmFormSelector);
    }, [candidateBprmFormSelector])

    const getLastWorkflowTask = (workflowTasks) => {
        const allTasks = workflowTasks.filter(
            (x) =>
                x.itemType === 1 &&
                x.applicantId !== x.performerId &&
                x.taskDoneStatus > 0
        );
        if (allTasks.length === 0) {
            return workflowTasks[workflowTasks.length - 1];
        }
        const tsk = allTasks[allTasks.length - 1];
        return tsk;
    };

    const closeACHInsu = () => {
        setSelectedInfo("");
        setAchType("");
        setInsuranceType("");
        setContractDocType("")
        handleSectionHideShow(false);
    }

    const handleACHShowHide = (mod, type, item, key, app) => {
        if (achType == type) return;
        dispatch(formLibraryReceived([]));
        dispatch(subsCurrentWfTaskReceived(null));
        dispatch(recCurrentWfTaskReceived(null));
        dispatch(receivedSubcontractorById([]));
        dispatch(receivedCandidateById([]));
        dispatch(receivedRecruiterById([]));
        setSelectedInfo(mod);
        setFetchedDataType("")
        setEditDurType("");
        setAchType(type);
        setInsuranceType("");
        setContractDocType("");
        handleSectionHideShow(true);
        const tsk = app.workflowTasks[app.workflowTasks.length - 1];
        setSelectedCurrentTask(tsk);
        setSelectedApp(app);
    }

    const handleInsuranceShowHide = (mod, type, item, key, app) => {
        if (insuranceType == type) return;
        dispatch(formLibraryReceived([]));
        dispatch(subsCurrentWfTaskReceived(null));
        dispatch(recCurrentWfTaskReceived(null));
        dispatch(receivedSubcontractorById([]));
        dispatch(receivedCandidateById([]));
        dispatch(receivedRecruiterById([]));
        setSelectedInfo(mod);
        setFetchedDataType("")
        setEditDurType("");
        setAchType("");
        setInsuranceType(type);
        setContractDocType("");
        handleSectionHideShow(true);
        const tsk = app.workflowTasks[app.workflowTasks.length - 1];
        setSelectedCurrentTask(tsk);
        setSelectedApp(app);
    }

    const handleNextTask = () => {
        console.log("")
    }
    const getAdminMspFee = (item) => {
        const feePer = getFieldData(
            item.performerData,
            "candidateonboardingform",
            "Msp_AdminFee"
        );

        // const feeDo = getFieldData(
        //     item.performerData,
        //     "projectengagement",
        //     "State_Admin_Fee_Amount"
        // )

        let mspData = <div>
            {feePer !== "" && feePer !== "0" && <>Admin Fee : <b>{feePer}%</b></>}
            {/* {feeDo !== "" && feeDo !== "0" && <><br />Tech Fee : <b>{feeDo}$/hr</b></>} */}
        </div>;


        return mspData;
    }

    const getAdminAgencyFee = (item) => {
        const feePer = getFieldData(
            item.performerData,
            "projectengagement",
            "State_Admin_Fee"
        );

        const feeDo = getFieldData(
            item.performerData,
            "projectengagement",
            "State_Admin_Fee_Amount"
        )

        if (feePer !== "" && feePer !== "0") {
            return <>State Admin Fee : <RateEncryptDecrypt rateData={feePer} startSymbol="" endSymbol="%" /></>
        }
        else if (feeDo !== "" && feeDo !== "0") {
            return <>State Admin Fee : <RateEncryptDecrypt rateData={feeDo} /></>
        }

        return "";
    }

    const handlePurchaseShowHide = (item, type, poType) => {
        setPurchaseShowHide(!purchaseShowHide);
        setCandidateObj(item);
        setPoOrderType(type);
        setSelectedItem({ partnerType: poType })
        if (item?.applications?.length > 0) {
            const tsk = item.applications[0].workflowTasks[item.applications[0].workflowTasks.length - 1];
            setSelectedCurrentTask(tsk);
        }
    };

    const handleSignUnsignPo = (unSignPo) => {
        //setPoCount(unSignPo);
    }

    const handleRefreshPoOrders = () => {
        // if (item?.partnerId)
        //   dispatch(loadPartnerPerformers(item.partnerId));
    }

    const handleDurationAndRateShowHide = (obj, type, key) => {
        console.log(type);
        closeACHInsu()
        setSelectedFormKey(-1)
        setFetchedDataType("ViewForm");
        setViewFormType("");
        setViewType("");
        if (fetchedDataType !== "ViewForm") {
            setEditDurType("");
            setSelectedKey(-1)
        }
        // if (type === "save") {
        //     if (dataType === "filter") handleFilter();
        //     else dispatch(loadCandidates(pageSize, currentPage, applicantType))
        // }
        //setSelectedObj(item);
        setViewShowHide(false);
        if (editDurType === type) {
            setEditDurType("");
            setSelectedKey(-1);
        }
        else {
            setEditDurType(type);
            setSelectedKey(key);
            if (type === "") handleSectionHideShow(false);
            else handleSectionHideShow(true);
        }

        // handleViewShowHide(obj, type, key)
    };

    const handleCloseViewForm = () => {
        setViewFormType("");
        setFetchedDataType("");
        setSelectedFormKey(-1);
        setWfTask(null);
        setWfId(0);
        setCandidateObj(null);
        setEntityType("");
        setW2type(null);
        dispatch(candidateBprmFormReceived(null));
        dispatch(subcontractorBprmFormReceived(null));
        dispatch(recruiterBprmFormReceived(null));
        setPartnerCurrentWfTask(null);
        handleSectionHideShow(false);
    }

    return (
        <React.Fragment>
            <div className="table-responsive border">
                <table className="table align-items-center table-flush table-hover table-striped mb-2">
                    <thead className="thead-light">
                        <tr>
                            <th>ID # <br />IPCS ID</th>
                            <th>Candidate</th>
                            <th>
                                Position Title
                                <br />
                                Entity Type
                            </th>
                            <th>Agency/Client</th>
                            <th>Subcontractor</th>
                            <th>Recruiter</th>
                            <th>MSP</th>
                            <th>Tech/Other Fee</th>
                            <th>Duration<br />(Start-End)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {item &&
                            <tr>
                                <td>
                                    {item.performerid}
                                    <br />
                                    {item.maxloans}
                                </td>
                                <td>
                                    <button
                                        onClick={() => handleViewcandidateForm("Candidate", 0, item)}
                                        className="btn p-0 btn-link btn-sm text-uppercase">
                                        {item.performername} {item.lastName}
                                    </button>
                                    <br />
                                    {item.performeremail}
                                    <br />
                                    {getFormatedNumber(item.contactNo)}
                                    <br />
                                    <Moment format="MMM Do YYYY, h:mm a">
                                        {item.addedDateTime}
                                    </Moment>
                                </td>
                                <td className="pb-0">
                                    {getFieldData(
                                        item.performerData,
                                        "projectengagement",
                                        "PositionTitle"
                                    ) && <>

                                            {getFieldData(
                                                item.performerData,
                                                "projectengagement",
                                                "PositionTitle"
                                            )}
                                            <br />
                                        </>}
                                    {getFieldData(
                                        item.performerData,
                                        "candidateonboardingform",
                                        "CandidateEntity"
                                    ) === "1099 Basis" && "1099"}
                                    {getFieldData(
                                        item.performerData,
                                        "candidateonboardingform",
                                        "CandidateEntity"
                                    ) === "C2C Basis" && "C2C"}
                                    {getFieldData(
                                        item.performerData,
                                        "candidateonboardingform",
                                        "CandidateEntity"
                                    ) === "1099 Basis" &&
                                        (
                                            <>
                                                <br />
                                                Rate : {item?.rates?.candidateRate ? <RateEncryptDecrypt rateData={item?.rates?.candidateRate} /> : "$0.00/Hr"}
                                            </>
                                        )}
                                    {getFieldData(
                                        item.performerData,
                                        "candidateonboardingform",
                                        "CandidateEntity"
                                    ) === "W2 Basis" && (
                                            <>
                                                {getFieldData(
                                                    item.performerData,
                                                    "candidateonboardingform",
                                                    "w9_Type"
                                                )}
                                                <br />
                                                Rate : {item?.rates?.candidateRate ? <RateEncryptDecrypt rateData={item?.rates?.candidateRate} /> : "$0.00/Hr"}
                                                <br />
                                                {
                                                    getFieldData(
                                                        item.performerData,
                                                        "candidateonboardingform",
                                                        "Per_Diem_Rate"
                                                    ) ? (
                                                        <>
                                                            Per Diem Rate :<RateEncryptDecrypt rateData={getFieldData(
                                                                item.performerData,
                                                                "candidateonboardingform",
                                                                "Per_Diem_Rate"
                                                            )} endSymbol="/Day" />
                                                        </>
                                                    ) : ""
                                                }
                                            </>
                                        )}
                                </td>
                                <td>
                                    <button className="btn p-0 btn-link btn-sm text-uppercase"
                                        //data-target="#collapseExample"
                                        //data-toggle="collapse"
                                        aria-label="View Agency"
                                        onClick={() => handleViewShowHide("agency")}>
                                        {getFieldData(
                                            item.performerData,
                                            "projectengagement",
                                            "AgencyName"
                                        )}
                                    </button>
                                    <br />
                                    Rate : {item?.rates?.agencyRate ? <RateEncryptDecrypt rateData={item?.rates?.agencyRate} /> : "$0.00/Hr"}
                                    <br />
                                    {getAdminAgencyFee(item)}
                                </td>
                                <td>
                                    {item?.subcontractor ? (
                                        <React.Fragment>
                                            <button
                                                className="btn p-0 btn-link btn-sm text-uppercase"
                                                onClick={() => handleViewcandidateForm("Subcontractor", 0, item)}
                                            >
                                                {item.subcontractor?.label}
                                                {item.subcontractor.useFlag ?
                                                    <i
                                                        className="fa fa-check text-success"
                                                        style={{ fontSize: "15px" }}
                                                        aria-hidden="true"
                                                    ></i> :
                                                    <i
                                                        className="fa fa-times text-danger"
                                                        style={{ fontSize: "15px" }}
                                                        aria-hidden="true"
                                                    ></i>}
                                            </button>
                                            <br />
                                            {item.validId !== null &&
                                                <>
                                                    ID : <b>{item.validId}</b>,
                                                </>}
                                            Rate : {item?.rates?.subcontractorRate ? <RateEncryptDecrypt rateData={item?.rates?.subcontractorRate} /> : "$0.00/Hr"}
                                            <br />
                                            {item.subcontractor !== null &&
                                                item.subcontractor.email}
                                            <br />
                                            {item.subcontractor && (
                                                <Moment format="MMM Do YYYY, h:mm a">
                                                    {item.subcontractor.createdDate}
                                                </Moment>
                                            )}
                                        </React.Fragment>
                                    ) : (
                                        "Not Applicable"
                                    )}
                                </td>
                                <td>
                                    {item?.recruiter ? (
                                        <React.Fragment>
                                            <button
                                                className="btn p-0 btn-link btn-sm text-uppercase"
                                                onClick={() => handleViewcandidateForm("Recruiter", 0, item)}
                                            >
                                                {item.recruiter?.label}
                                                {item.recruiter.useFlag ?
                                                    <i
                                                        className="fa fa-check text-success"
                                                        style={{ fontSize: "15px" }}
                                                        aria-hidden="true"
                                                    ></i> :
                                                    <i
                                                        className="fa fa-times text-danger"
                                                        style={{ fontSize: "15px" }}
                                                        aria-hidden="true"
                                                    ></i>}
                                            </button>
                                            <br />
                                            {item.recruiter?.fuid !== null &&
                                                <>
                                                    ID : <b>{item.recruiter?.fuid}</b>,
                                                </>}
                                            Rate : {item?.rates?.recruiterRate ? <RateEncryptDecrypt rateData={item?.rates?.recruiterRate} /> : "$0.00/Hr"}
                                            <br />
                                            {item.recruiter.email}
                                            <br />
                                            <Moment format="MMM Do YYYY, h:mm">
                                                {item.recruiter.createdDate}
                                            </Moment>
                                        </React.Fragment>
                                    ) : (
                                        "NA"
                                    )}
                                </td>

                                <td>
                                    {getFieldData(
                                        item.performerData,
                                        "candidateonboardingform",
                                        "Msp_Mode"
                                    ) !== "" && (
                                            <>
                                                <button
                                                    className="btn btn-sm btn-link p-0"
                                                    onClick={() => handleViewShowHide("msp")}
                                                >
                                                    {getFieldData(
                                                        item.performerData,
                                                        "candidateonboardingform",
                                                        "Msp_Mode"
                                                    ) === "Others" ?
                                                        getFieldData(
                                                            item.performerData,
                                                            "candidateonboardingform",
                                                            "MSP_Other_Mode"
                                                        ) :
                                                        getFieldData(
                                                            item.performerData,
                                                            "candidateonboardingform",
                                                            "Msp_Mode"
                                                        )}
                                                </button>
                                                <br />
                                                Admin Fee : <RateEncryptDecrypt rateData={getFieldData(item.performerData, "candidateonboardingform", "Msp_AdminFee")} startSymbol="" endSymbol="%" />
                                            </>
                                        )}


                                </td>
                                <td>
                                    Candidate : {item?.rates?.candidateTechFee ? <RateEncryptDecrypt rateData={item?.rates?.candidateTechFee} /> : "$0.00/Hr"}
                                    <br />
                                    Subcontractor : {item?.rates?.subcontractorTechFee ? <RateEncryptDecrypt rateData={item?.rates?.subcontractorTechFee} /> : "$0.00/Hr"}
                                    <br />
                                    Recruiter : {item?.rates?.recruiterTechFee ? <RateEncryptDecrypt rateData={item?.rates?.recruiterTechFee} /> : "$0.00/Hr"}
                                    <p className="mt-1"> Hub Fee : {getFieldData(item.performerData, "candidateonboardingform", "Hub_CompanyFee") ?
                                        <RateEncryptDecrypt rateData={getFieldData(item.performerData, "candidateonboardingform", "Hub_CompanyFee")} startSymbol="" endSymbol="%" /> : "%"}</p>
                                </td>
                                <td>
                                    {item.duration && (
                                        <React.Fragment>
                                            {item.duration.duration} Months
                                            <br />
                                            Start :{" "}
                                            <Moment format="MMM Do YYYY">
                                                {item.duration.startDate}
                                            </Moment>
                                            <br />
                                            End :{" "}
                                            <Moment format="MMM Do YYYY">
                                                {item.duration.endDate}
                                            </Moment>
                                        </React.Fragment>
                                    )}
                                    <br />
                                    <button
                                        className="btn btn-sm btn-link p-0"
                                        onClick={() =>
                                            handleDurationAndRateShowHide(
                                                item,
                                                "duration", 0
                                            )
                                        }
                                    >
                                        Edit Duration
                                    </button>
                                    <br />
                                    <button
                                        className="btn btn-sm btn-link p-0"
                                        onClick={() =>
                                            handleDurationAndRateShowHide(item, "rate", 0)
                                        }
                                    >
                                        Modify Rates
                                    </button>
                                </td>
                            </tr>}
                        <tr className="bg-white">
                            <>
                                <td colSpan={1} className="border-0 pt-0 pb-1"></td>
                                <td colSpan={2} className="border-0 pt-0 pb-1" >

                                    <>
                                        {type !== "candetails" &&
                                            <button
                                                onClick={() => handleDocumentViewShowHide("Candidate")}
                                                className="btn btn-sm btn-link p-0"
                                                title="Contract Documents"
                                            >
                                                Send Contract Documents
                                            </button>}

                                        {type !== "candetails" && getFieldData(
                                            item.performerData,
                                            "candidateonboardingform",
                                            "CandidateEntity"
                                        ) !== "C2C Basis" && <>
                                                <br />
                                                <button
                                                    onClick={() => handleACHShowHide("ACH", "Candidate", item, 1, app)}
                                                    className="btn btn-sm btn-link p-0"
                                                    title="Contract Documents"
                                                >
                                                    ACH Information <span className="badge badge-pill badge-danger">{app?.achRequest}</span>
                                                </button>
                                                {/* <br />
                                                    <button
                                                        onClick={() => handleInsuranceShowHide("Insurance", "Candidate", item, 1, app)}
                                                        className="btn btn-sm btn-link p-0"
                                                        title="Contract Documents"
                                                    >
                                                        Insurance Information
                                                    </button> */}
                                            </>}
                                    </>
                                </td>
                                <td className="border-0 pt-0">
                                    {type !== "candetails" && getFieldData(
                                        item.performerData,
                                        "projectengagement",
                                        "AgencyName"
                                    ) &&
                                        <button
                                            onClick={() => handleDocumentViewShowHide("agency")}
                                            className="btn btn-sm btn-link p-0"
                                            title="Contract Documents"
                                        >
                                            Upload Document
                                        </button>}
                                </td>
                                <td className="border-0 pt-0">
                                    {getFieldData(
                                        item.performerData,
                                        "candidateonboardingform",
                                        "CandidateEntity"
                                    ) === "C2C Basis" ? (
                                        item.subcontractor?.fuid && (
                                            type === "candetails" ? <button
                                                className="btn btn-sm btn-link p-0 text-left"
                                                onClick={() => handlePurchaseShowHide(item, "view", "Sub-Contractors")}
                                            >
                                                View Purchase Order
                                            </button> : <button
                                                onClick={() => handleDocumentViewShowHide("Subcontractor")}
                                                className="btn btn-sm btn-link p-0"
                                                title="Contract Documents"
                                            >
                                                Send Documents
                                            </button>
                                        )
                                    ) : ("")}
                                </td>
                                <td className="border-0 pt-0">
                                    {item.recruiter !== null && (
                                        type === "candetails" ? <button
                                            className="btn btn-sm btn-link p-0 text-left"
                                            onClick={() => handlePurchaseShowHide(item, "view", "Recruiter")}
                                        >
                                            View Purchase Order
                                        </button> :
                                            <button
                                                onClick={() => handleDocumentViewShowHide("Recruiter")}
                                                className="btn btn-sm btn-link p-0"
                                                title="Contract Documents"
                                            >
                                                Send Documents
                                            </button>)
                                    }
                                </td>
                                <td className="border-0 pt-0">
                                    {type !== "candetails" && getFieldData(
                                        item.performerData,
                                        "candidateonboardingform",
                                        "Msp_Mode"
                                    ) !== "" && (
                                            <button
                                                onClick={() => handleDocumentViewShowHide("msp")}
                                                className="btn btn-sm btn-link p-0"
                                                title="Contract Documents"
                                            >
                                                Upload Document
                                            </button>)}
                                </td>
                                <td colSpan={2} className="border-0 pt-0"></td>
                            </>
                        </tr>

                        <tr className="bg-white">
                            <>
                                <td colSpan={1} className="border-0 pt-0 pb-1"></td>
                                <td colSpan={1} className="border-0 pt-0 pb-1" >
                                    <>
                                        {type !== "candetails" && getFieldData(
                                            item.performerData,
                                            "candidateonboardingform",
                                            "CandidateEntity"
                                        ) === "W2 Basis" && <div className="d-flex flex-column align-items-start">
                                                <button
                                                    className="btn btn-sm btn-link p-0"
                                                    title="Coming Soon....."
                                                >
                                                    I9 Verification
                                                </button>
                                            </div>}

                                    </>
                                </td>
                                <td colSpan={2} className="border-0 pt-0 pb-1"></td>
                                <td colSpan={1} className="border-0 pt-0 pb-1" >
                                    {getFieldData(
                                        item.performerData,
                                        "candidateonboardingform",
                                        "CandidateEntity"
                                    ) === "C2C Basis" ? (
                                        item.subcontractor?.fuid && (
                                            <>
                                                <div className="d-flex flex-column align-items-start">
                                                    {/* <button
                                                            onClick={() => handleACHShowHide("ACH", "Subcontractor", item)}
                                                            className="btn btn-sm btn-link p-0"
                                                            title="Contract Documents"
                                                        >
                                                            ACH Information
                                                        </button>
                                                        <button
                                                            onClick={() => handleInsuranceShowHide("Insurance", "Subcontractor", item)}
                                                            className="btn btn-sm btn-link p-0"
                                                            title="Contract Documents"
                                                        >
                                                            Insurance Information
                                                        </button> 
                                                        <button
                                                            className="btn btn-sm btn-link p-0 text-left"
                                                            onClick={() => handlePurchaseShowHide(item, "add", "Sub-Contractors")}
                                                        >
                                                            Send Purchase Order
                                                        </button> */}
                                                </div>
                                            </>
                                        )
                                    ) : ("")}
                                </td>
                                <td colSpan={1} className="border-0 pt-0 pb-1" >
                                    {item.recruiter !== null ? (
                                        <div className="d-flex flex-column align-items-start">
                                            {/* <button
                                                    onClick={() => handleACHShowHide("ACH", "Recruiter", item)}
                                                    className="btn btn-sm btn-link p-0"
                                                    title="Contract Documents"
                                                >
                                                    ACH Information
                                                </button>
                                                <button
                                                    onClick={() => handleInsuranceShowHide("Insurance", "Recruiter", item)}
                                                    className="btn btn-sm btn-link p-0"
                                                    title="Contract Documents"
                                                >
                                                    Insurance Information
                                                </button> 
                                                <button
                                                    className="btn btn-sm btn-link p-0 text-left"
                                                    onClick={() => handlePurchaseShowHide(item, "add", "Recruiter")}
                                                >
                                                    Send Purchase Order
                                                </button> */}
                                        </div>
                                    ) : ("")}
                                </td>
                                <td colSpan={3} className="border-0 pt-0 pb-1"></td>
                            </>
                        </tr>
                        {editDurType !== "" && fetchedDataType === "Document" &&
                            <td colSpan={13} className="bg-white p-3">
                                <div className="text-left mb-4 pr-0">
                                    <button
                                        className="btn btn-sm btn-outline-default"
                                        onClick={handleCloseDocumentView}
                                    >
                                        <i className="fa fa-times mr-2"></i>Close
                                    </button>
                                </div>
                                <div className="text-center mt--5"><h3 className="text-uppercase">{editDurType} Documents</h3></div>
                                <Document
                                    documents={appDocuments}
                                    workflowTask={selectedCurrentTask}
                                    uploadType={`${editDurType}`}
                                    app={app}
                                    item={item}
                                    pageModule={"review"}
                                    viewType={(editDurType === "Subcontractor" || editDurType === "Recruiter") ? "candidateList" : ""}
                                    type={type}
                                />
                            </td>}
                        {selectedInfo === "ACH" &&
                            <td colSpan={13} className="bg-white p-3">
                                <div className="text-left mb-3 pr-0">
                                    <button
                                        className="btn btn-sm btn-outline-default"
                                        onClick={() => closeACHInsu()}
                                    >
                                        <i className="fa fa-times mr-2"></i>Close
                                    </button>
                                </div>
                                <div className="text-center mt--4"><h3>{achType} ACH Information</h3></div>
                                <AchInformation
                                    workflowTask={selectedCurrentTask}
                                    app={selectedApp}
                                    item={item}
                                    setViewBprmFormShowHide={setViewBprmFormShowHide}
                                    viewType={"candidateList1"}
                                    achType={achType}
                                    setSelectedApp={setSelectedApp}
                                />
                            </td>}
                        {selectedInfo === "Insurance" &&
                            <td colSpan={13} className="bg-white p-3">
                                <div className="text-left mb-3 pr-0">
                                    <button
                                        className="btn btn-sm btn-outline-default"
                                        onClick={() => closeACHInsu()}
                                    >
                                        <i className="fa fa-times mr-2"></i>Close
                                    </button>
                                </div>
                                <div className="text-center mt--4"><h3>{insuranceType} Insurance Information</h3></div>
                                <InsuranseInformation
                                    workflowTask={selectedCurrentTask}
                                    app={selectedApp}
                                    item={item}
                                    setViewBprmFormShowHide={setViewBprmFormShowHide}
                                    viewType={"candidateList1"}
                                    insuranceType={insuranceType}
                                    setSelectedApp={setSelectedApp}
                                />
                            </td>}
                    </tbody>
                </table>
            </div>
            {viewType !== "" && viewShowHide &&
                <div className="p-3 border mt-2">
                    <ViewCandidate
                        handleDurationShowHide={handleDurationAndRateShowHide}
                        heading={""}
                        viewShowHide={viewShowHide}
                        handleViewShowHide={handleViewShowHide}
                        selectedObj={item}
                        viewType={viewType}
                        filterSubcontractorList={[]}
                        filterRecruiterList={[]}
                    ></ViewCandidate>
                </div>}
            {wfForm &&
                <div className="p-3 border mt-2">
                    <div className="d-flex justify-content-between align-items-center mb-3 pr-0">
                        <button
                            className="btn btn-sm btn-outline-default"
                            onClick={() => handleCloseViewForm(`${viewFormType}`, 0, null)}
                        >
                            <i className="fa fa-times mr-2"></i>Close
                        </button>
                        <h2 className="m-0 text-center text-capitalize ms-3">{viewFormType} Details</h2>
                        <div></div>
                    </div>
                    <WorkflowElement
                        wfTask={wfTask}
                        wfForm={wfForm}
                        handleNextTask={handleNextTask}
                        viewType={true}
                        appSummary={false}
                        codeVerified={true}
                        wfTaskType={"form"}
                        // actionType={"workflow"}
                        updatedStateData={updatedStateData}
                    />
                </div>}

            {editDurType === "duration" && <AddEditDuration
                handleDurationShowHide={handleDurationAndRateShowHide}
                selectedObj={candidate}
                editType={editDurType}
            ></AddEditDuration>}

            {editDurType === "rate" && <AddEditRates
                handleDurationShowHide={handleDurationAndRateShowHide}
                selectedObj={candidate}
                editType={editDurType}
            ></AddEditRates>}

            {purchaseShowHide && <PurchaseOrderPopup
                purchaseShowHide={purchaseShowHide}
                handlePurchaseShowHide={handlePurchaseShowHide}
                candidateObj={candidateObj}
                workflowTask={selectedCurrentTask}
                poOrderType={poOrderType}
                item={selectedItem}
                handleSignUnsignPo={handleSignUnsignPo}
                handleRefreshPoOrders={handleRefreshPoOrders}
            ></PurchaseOrderPopup>}
        </React.Fragment>
    )
}

